import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

interface Interface {
  delete: (id: string) => Promise<void>;
}

export class StoreManagementAssociateBrandService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async delete(id: string): Promise<void> {
    return await this.restClient.delete(
      `${TABLET_API_ORIGIN}/dashboard-api/associate-brands/${id}` as const
    );
  }
}
